<aside class="list">
  @for (item of items(); track item.key) {
    <button
      class="item"
      type="button"
      [class.active]="item.active"
      [class.empty]="item.state === 'empty'"
      [class.selected]="item.state === 'selected'"
      [disabled]="item.disabled"
      [attr.aria-current]="item.active"
      (click)="itemSelect.emit(item.key)"
    >
      <span class="title">
        @if (titleTemplate(); as template) {
          <ng-container *ngTemplateOutlet="template; context: { $implicit: item }" />
        } @else {
          {{ item.label }}
        }
      </span>
      <span class="meta">{{ item.meta }}</span>
      <span class="badge">
        <span class="count">
          @if (item.selectedCount > 0) {
            <mat-icon class="icon">task_alt</mat-icon>
          }
          {{ item.selectedCount }}
        </span>
      </span>
    </button>
  }
</aside>
